"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const LongPressButton_1 = require("./LongPressButton");
const Button = (props) => {
    const { children, color, loading, size, innerRef, tag, className } = props, rest = __rest(props, ["children", "color", "loading", "size", "innerRef", "tag", "className"]);
    const buttonClasses = classnames_1.default({
        [className]: !!className,
        'btn': true,
        'btn-link': color === 'link-secondary' || color === 'link-img' || color === 'link-back',
        'btn-with-loader': !!loading,
        [`btn-${color}`]: !!color,
        [`btn-${size}`]: color === 'primary' || color === 'primary-green' ||
            color === 'secondary' || color === 'tertiary' ||
            color === 'tertiary-up' || color === 'tertiary-down' ||
            color === 'tertiary-left' || color === 'tertiary-right',
        [`btn-add--${size}`]: color === 'add' && size,
    });
    if ('longPress' in props) {
        return (React.createElement(LongPressButton_1.LongPressButton, Object.assign({ disabled: loading || rest.disabled }, rest, { className: buttonClasses, size: size }), children));
    }
    const _a = rest, { href } = _a, attributes = __rest(_a, ["href"]);
    let Tag = tag;
    if (!!href && tag === 'button') {
        Tag = 'a';
    }
    let content = children;
    if (color === 'link' || color === 'link-secondary' || color === 'link-back') {
        content = React.createElement("span", null, children);
    }
    if (color === 'add') {
        content = (React.createElement(react_1.Fragment, null,
            React.createElement("span", { className: `add-plus` }),
            React.createElement("span", { className: "btn-add-text" }, children)));
    }
    if (color === 'back') {
        content = (React.createElement(react_1.Fragment, null,
            React.createElement("span", { className: "back-icon" }),
            React.createElement("span", { className: "btn-back-text" }, children)));
    }
    if (color === 'tertiary') {
        content = (React.createElement("span", null, children));
    }
    if (color === 'tertiary-up') {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", null, children),
            React.createElement(Icon_1.default, { icon: 'arrow_up_blue_dark' })));
    }
    if (color === 'tertiary-down') {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", null, children),
            React.createElement(Icon_1.default, { icon: 'arrow_down_blue_dark' })));
    }
    if (color === 'tertiary-left') {
        content = (React.createElement(React.Fragment, null,
            React.createElement(Icon_1.default, { icon: 'arrow_left_blue_dark' }),
            React.createElement("span", null, children)));
    }
    if (color === 'tertiary-right') {
        content = (React.createElement(React.Fragment, null,
            React.createElement("span", null, children),
            React.createElement(Icon_1.default, { icon: 'arrow_right_blue_dark' })));
    }
    return (React.createElement(Tag, Object.assign({ href: href }, attributes, { disabled: loading || attributes.disabled, className: buttonClasses, ref: innerRef }), content));
};
Button.defaultProps = {
    color: 'primary',
    size: 'md',
    tag: 'button',
};
exports.default = Button;
//# sourceMappingURL=Button.js.map